const quickLinks = [
  { label: "热门爆料", href: "#hot" },
  { label: "主题分类", href: "#categories" },
  { label: "最新爆料", href: "#feed" },
  { label: "投稿指引", href: "#submit" },
];

const topicLinks = [
  { label: "城市见闻", href: "#categories" },
  { label: "生活消费", href: "#categories" },
  { label: "科技数码", href: "#categories" },
  { label: "职场观察", href: "#categories" },
];

const helpLinks = [
  { label: "常见问题", href: "#faq" },
  { label: "留言反馈", href: "#about" },
  { label: "内容原则", href: "#about" },
  { label: "关于我们", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                99
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">99看料</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              一个把热点线索汇聚起来的地方。每一条内容下方都可以参与讨论，你的补充与看法，也许就是下一条料的起点。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 font-label text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600" aria-hidden="true" />
              hello@99kanliao.example
            </p>
          </div>

          <nav aria-label="快捷入口">
            <h4 className="font-heading text-base font-semibold text-foreground-950">快捷入口</h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h4 className="font-heading text-base font-semibold text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-3">
              {topicLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="帮助与反馈">
            <h4 className="font-heading text-base font-semibold text-foreground-950">帮助与反馈</h4>
            <ul className="mt-4 space-y-3">
              {helpLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300 pt-6 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <p className="font-label text-xs text-foreground-500">
            © {new Date().getFullYear()} 99看料 · 热点线索分享与讨论社区
          </p>
          <p className="font-label text-xs text-foreground-500">
            内容由用户分享，观点仅代表发布者本人
          </p>
        </div>
      </div>
    </footer>
  );
}